import { useEffect, useState } from 'react';
export default function useResize(elementRef) {
    const [offsetWidth, setOffsetWidth] = useState(0);
    const handleResize = () => {
        setOffsetWidth(elementRef.current.offsetWidth);
    };
    useEffect(() => {
        setOffsetWidth(elementRef.current.offsetWidth);
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return { width: offsetWidth, handleResize };
}
